export default __webpack_public_path__ + "static/media/express.66ff7b77.svg";